export default {
  pt: {
    pageTitle: "Privacidade",
    mainTitle: "Política de Privacidade",
    lastUpdated: "Atualizado em 19/10/2026",
    intro:
      "A BikeHero tem o compromisso de proteger sua privacidade. Esta Política de Privacidade explica como suas informações pessoais são coletadas, usadas e divulgadas quando você acessa e usa este site para contratar o seguro da sua bicicleta ou outro equipamento de mobilidade.",

    sections: [
      {
        title: "Como coletamos dados pessoais sobre você",
        body:
          "<p>Praticamente todos os seus dados pessoais são coletados diretamente de você, ao longo da jornada de " +
          "contratação do seguro. Essa jornada começa quando você acessa o link de contratação (recebido de um " +
          "parceiro, QR code, anúncio ou outro canal) e segue pelas etapas de cotação, preenchimento dos seus dados " +
          "pessoais, cadastro das informações da sua bicicleta, verificação de identidade (selfie e e-mail) e " +
          "pagamento, até a emissão da apólice.</p>" +
          "<p>Além disso, coletamos de forma automática informações sobre o seu acesso a essa jornada (origem e " +
          'navegador), conforme detalhado na seção "Dados de acesso e navegação" abaixo.</p>',
      },
      {
        title: "Quais são as informações que coletamos",
        body:
          "<ul>" +
          "<li>Nome</li>" +
          "<li>CPF</li>" +
          "<li>Números de telefone</li>" +
          "<li>Endereço de e-mail</li>" +
          "<li>Endereços de correio e de faturamento</li>" +
          "<li>Marca, modelo, componentes e ano da bicicleta</li>" +
          "<li>Número de série (chassi) da bicicleta</li>" +
          "<li>Fotos e vídeos enviados através do site</li>" +
          "<li>Dados para pagamento</li>" +
          "</ul>",
      },
      {
        title: "Dados de acesso e navegação",
        body:
          "<p>O seu acesso a esta jornada de contratação também é registrado, de forma automática, logo na primeira página " +
          "que você abre. Esse registro guarda: o link utilizado para chegar até aqui; se o acesso partiu do nosso site " +
          "institucional ou de outra origem; e o navegador e o tipo de aparelho (celular ou computador) que você está " +
          "usando (essa última informação vem de um dado que todo navegador envia automaticamente, chamado " +
          '"User-Agent", e não depende de nenhuma ação sua).</p>' +
          "<p>Esse registro é associado ao seguro que você eventualmente contratar, e é mantido por até 1 (um) ano, prazo " +
          "após o qual é excluído ou anonimizado, de forma independente do prazo de guarda aplicável aos demais dados do " +
          "seu contrato. Usamos essa informação só para duas finalidades: entender por quais canais as pessoas estão " +
          "chegando até este site (sem tomar nenhuma decisão individual sobre você a partir disso) e identificar problemas " +
          "técnicos que aconteçam só em determinados navegadores ou aparelhos. Não usamos nenhuma ferramenta de " +
          "rastreamento de terceiros para isso: a informação fica só no nosso próprio banco de dados.</p>",
      },
      {
        title: "Como usamos as informações que coletamos",
        body:
          "<p>Usamos as informações, basicamente, para viabilizar a contratação do seu seguro, para atendimento das " +
          "exigências das autoridades públicas e para ações que atendam o interesse legítimo dos nossos clientes. " +
          "Qualquer uma das informações que coletamos de você pode ser usada para:</p>" +
          "<ul>" +
          "<li>Envio à companhia de seguros, possibilitando a ela fazer a análise do risco, precificação, emissão da " +
          "apólice e regulação do sinistro;</li>" +
          "<li>Contato de consultores para oferecer outros produtos, serviços e vantagens;</li>" +
          "<li>Melhorar o atendimento ao cliente;</li>" +
          "<li>Composição de um banco de dados de registro de bicicletas, para verificação de autenticidade e " +
          "propriedade, podendo ser compartilhado com empresas afins, inclusive para consulta de bicicletas roubadas;</li>" +
          "<li>Envio de e-mails referentes ao serviço que você contratou.</li>" +
          "</ul>",
      },
      {
        title: "Por quanto tempo mantemos suas informações",
        body:
          "<p>Mantemos suas informações apenas enquanto precisamos para fornecer os serviços da BikeHero a você e cumprir " +
          "as exigências dos órgãos oficiais, incluindo a Superintendência de Seguros Privados. Quando não precisarmos " +
          "mais usar suas informações e não houver necessidade de mantê-las para cumprir obrigações legais ou " +
          "regulamentares, iremos removê-las de nossos sistemas ou anonimizá-las.</p>",
      },
      {
        title: "Como protegemos os seus dados",
        body:
          "<p>Implementamos medidas de segurança para proteger suas informações pessoais quando você acessa este site ou " +
          "insere, envia ou acessa suas informações. Todas as informações confidenciais são transmitidas por meio de " +
          "tecnologia de criptografia (SSL/TLS). Ainda assim, nenhum sistema de segurança é infalível, e não podemos " +
          "garantir a segurança absoluta de qualquer informação transmitida para a BikeHero.</p>",
      },
      {
        title: "Seus direitos como titular dos dados",
        body:
          "<p>Você tem o direito de acessar, atualizar, corrigir e solicitar a exclusão dos seus dados pessoais, bem como " +
          "de se opor ao tratamento feito com base em legítimo interesse (como é o caso dos dados de acesso e navegação " +
          "descritos acima). Alguns dados e documentos do seu contrato de seguro, porém, precisam ficar armazenados por " +
          "mais tempo, para cumprimento da legislação da Superintendência de Seguros Privados. Para exercer qualquer um " +
          "desses direitos, entre em contato pelo canal abaixo.</p>",
      },
      {
        title: "Mudanças nesta Política de Privacidade",
        body:
          "<p>Podemos alterar esta Política de Privacidade para refletir com precisão os serviços deste site. Se uma " +
          "revisão for relevante, publicaremos essas alterações nesta própria página, com a data de atualização.</p>",
      },
      {
        title: "Contate-nos",
        body: "<p>Não hesite em nos contactar se tiver alguma questão, pelo e-mail app@bikehero.com.br.</p>",
      },
    ],
  },

  en: {
    pageTitle: "Privacy",
    mainTitle: "Privacy Policy",
    lastUpdated: "Updated on 10/19/2026",
    intro:
      "BikeHero is committed to protecting your privacy. This Privacy Policy explains how your personal information " +
      "is collected, used and disclosed when you access and use this site to purchase insurance for your bicycle or " +
      "other mobility equipment.",

    sections: [
      {
        title: "How we collect personal data about you",
        body:
          "<p>Practically all of your personal data is collected directly from you, throughout the insurance purchase " +
          "journey. This journey starts when you access the purchase link (received from a partner, QR code, " +
          "advertisement or other channel) and continues through the quote, your personal information, your bike's " +
          "information, identity verification (selfie and email) and payment steps, up to policy issuance.</p>" +
          "<p>We also automatically collect information about your access to this journey (origin and browser), as " +
          'detailed in the "Access and browsing data" section below.</p>',
      },
      {
        title: "What information do we collect",
        body:
          "<ul>" +
          "<li>Name</li>" +
          "<li>Taxpayer ID (CPF)</li>" +
          "<li>Phone numbers</li>" +
          "<li>Email address</li>" +
          "<li>Mailing and billing addresses</li>" +
          "<li>Bike brand, model, components and year</li>" +
          "<li>Bike serial number</li>" +
          "<li>Photos and videos submitted through the site</li>" +
          "<li>Payment data</li>" +
          "</ul>",
      },
      {
        title: "Access and browsing data",
        body:
          "<p>Your access to this purchase journey is also automatically recorded, right on the first page you open. This " +
          "record stores: the link used to get here; whether the access came from our institutional site or from another " +
          "source; and the browser and device type (mobile or desktop) you are using (this last piece of information " +
          'comes from data every browser automatically sends, called "User-Agent", and does not depend on any action ' +
          "from you).</p>" +
          "<p>This record is associated with the insurance you eventually purchase, and is kept for up to 1 (one) year, " +
          "after which it is deleted or anonymized, independently of the retention period applicable to the rest of " +
          "your contract data. We use this information only for two purposes: understanding through which channels " +
          "people are reaching this site (without making any individual decision about you from it) and identifying " +
          "technical issues that only happen on certain browsers or devices. We do not use any third-party tracking tool " +
          "for this: the information stays only in our own database.</p>",
      },
      {
        title: "How we use the information we collect",
        body:
          "<p>We use the information, basically, to enable your insurance purchase, to meet requirements from public " +
          "authorities and for actions that serve our customers' legitimate interest. Any information we collect from you " +
          "may be used to:</p>" +
          "<ul>" +
          "<li>Send to the insurance company, enabling risk analysis, pricing, policy issuance and claims handling;</li>" +
          "<li>Allow consultants to contact you to offer other products, services and benefits;</li>" +
          "<li>Improve customer service;</li>" +
          "<li>Build a bike registration database, for ownership and authenticity verification, which may be shared with " +
          "related companies, including for stolen bike lookups;</li>" +
          "<li>Send emails related to the service you purchased.</li>" +
          "</ul>",
      },
      {
        title: "How long we keep your information",
        body:
          "<p>We keep your information only for as long as needed to provide BikeHero's services to you and to meet " +
          "official regulatory requirements, including those from Brazil's insurance regulator (Susep). When we no " +
          "longer need your information and there is no legal or regulatory requirement to keep it, we will remove it " +
          "from our systems or anonymize it.</p>",
      },
      {
        title: "How we protect your data",
        body:
          "<p>We implement security measures to protect your personal information when you access this site or enter, " +
          "submit or access your information. All confidential information is transmitted using encryption technology " +
          "(SSL/TLS). Even so, no security system is foolproof, and we cannot guarantee the absolute security of any " +
          "information transmitted to BikeHero.</p>",
      },
      {
        title: "Your rights as a data subject",
        body:
          "<p>You have the right to access, update, correct and request deletion of your personal data, as well as to " +
          "object to processing based on legitimate interest (as is the case of the access and browsing data described " +
          "above). Some data and documents from your insurance contract, however, need to be kept longer, to comply with " +
          "regulatory requirements. To exercise any of these rights, contact us through the channel below.</p>",
      },
      {
        title: "Changes to this Privacy Policy",
        body:
          "<p>We may change this Privacy Policy to accurately reflect this site's services. If a revision is material, " +
          "we will publish those changes on this same page, along with the update date.</p>",
      },
      {
        title: "Contact us",
        body: "<p>Feel free to contact us if you have any questions, at app@bikehero.com.br.</p>",
      },
    ],
  },
};
